import {
  index,
  integer,
  sqliteTable,
  text,
  uniqueIndex,
} from "drizzle-orm/sqlite-core";
import { timestamps } from "@/db/columns.helpers";
import { activity } from "@/db/schema/activities";

export const activityInstance = sqliteTable(
  "activity_instance",
  {
    id: integer("id").primaryKey({ autoIncrement: true }),
    provider: text("provider").notNull(),
    type: text("type")
      .notNull()
      .references(() => activity.id),
    externalId: text("external_id").notNull(),
    metadata: text("metadata", { mode: "json" }).$type<
      Record<string, unknown>
    >(),
    ...timestamps,
  },
  (table) => [
    uniqueIndex("activity_instance_provider_external_unique").on(
      table.provider,
      table.externalId,
    ),
    index("activity_instance_provider_type_idx").on(table.provider, table.type),
    index("activity_instance_type_idx").on(table.type),
  ],
);

export type ActivityInstance = typeof activityInstance.$inferSelect;
export type ActivityInstanceInsert = typeof activityInstance.$inferInsert;
